const initialState = [];

const sourcesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SOURCES":
            return (state = action.payload);
        default:
            return state;
    }
};


export default sourcesReducer;